import styled from "styled-components";
import { Modal as AntModal, Button as AntButton } from "antd";
import { PocketMoneyBG } from "@assets";

export const Modal = styled(AntModal)`
	/* position: relative; */
	.ant-modal-content {
		background-image: url(${PocketMoneyBG});
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
		width: 365px;
		height: 423px;
		/* height: 3px; */
		box-shadow: none !important;
		background-color: transparent !important;
	}
	@media screen and (max-width: 413px) {
		width: 265px !important;
		height: 323px !important;
		.ant-modal-content {
			width: 265px;
			height: 323px;
		}
	}
`;

export const ModalTitle = styled.p`
	color: ${(props) => props.theme.white};
	font-size: 22px;
	font-weight: bold;
	margin-top: 80px;
	margin-bottom: 10px;
	@media screen and (max-width: 413px) {
		margin-bottom: 3px;
		margin-top: 60px;
	}
`;

export const ModalLabel = styled.p`
	font-size: 14px;
	text-align: center;
	font-weight: 400;
	color: ${(props) => props.theme.primarySolid};
	margin-bottom: 20px;
	@media screen and (max-width: 413px) {
		margin-bottom: 3px;
	}
`;

export const AmountWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 208px !important;
	height: 47px !important;
	border-radius: 27px;
	background: ${(props) => props.theme.golden};
	@media screen and (max-width: 413px) {
		width: 150px !important;
		height: 30px !important;
	}
`;

export const Button = styled(AntButton)`
	width: 208px !important;
	height: 47px !important;
	border-radius: 27px;
  background: transparent !important;
  color: ${props => props.theme.white};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-top: 20px;
	@media screen and (max-width: 413px) {
		width: 150px !important;
		height: 30px !important;
	}
`;

export const ExpiredText = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
	margin-top: 50px;
	color: rgba(255, 255, 255, 1);
`;

export const ExpiredDate = styled.p`
	color: ${props => props.theme.primarySolid};
`

